"use client"

import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';

const About = () => {
    // const id = useParams();
    const baseURL = process.env.NEXT_PUBLIC_BASE_URL;
    const [post, setPost] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch a single post from WordPress REST API

        // fetch(`https://hasangad.com/support/api/wp/v2/posts/${id}`)
        fetch(`https://site.figmawya.com/api/wp/v2/pages/102`)
            .then(response => response.json())
            .then(data => {
                setPost(data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setLoading(false);
            });
    }, []);

    return (
        <article className='card rounded-4 py-3 py-md-2 px-3 px-md-5 bg-white border col-12 col-xl-8 mx-auto'>
            {loading ? (
                <div className='mx-auto my-5'>جار جلب البيانات ... <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                </div> </div>
            ) : (
                <>
                    <h2 className='border-bottom mt-3 mb-4'>{post.title && post.title.rendered}</h2>
                    {post.content ? <div dangerouslySetInnerHTML={{ __html: post.content.rendered }}></div> : null}
                </>
            )
            }

            {/* <p className="d-none d-md-block">اسمى : الفيجماوية الله ، أُعرف في مجال حلول تقنية المعلومات بإسم <b>فيجماوية</b> ،
                مهندس تجربة المستخدم
                🙂 ، مصري ، كنت
                أستخدم موقعي هذا في تقديم خدمات العمل الحر Freelancing , متوقف حالياً عن تقديم الخدمات ، شكراً
                لثقتكم ويشرفني مروركم
                .</p> */}


            {/* {loading ? (
                <p>Loading...</p>
            ) : (
                <div>
                    <h2>{post.title && post.title.rendered}</h2>
                    <div dangerouslySetInnerHTML={{ __html: post.content && post.content.rendered }} />
                </div>
            )} */}
        </article>
    );
};

export default About;
